export var loadScript = function (url, checkFn, scriptArgs) {
    if (scriptArgs === void 0) { scriptArgs = null; }
    var resolve;
    var checkCount = 0;
    var checkCountmax = 60; // 最长等待3秒
    var promise = new Promise(function (_res) {
        resolve = _res;
    });
    var script = document.createElement('script');
    if (scriptArgs) {
        var keys = Object.keys(scriptArgs);
        keys.forEach(function (key) {
            script.setAttribute(key, scriptArgs[key]);
        });
    }
    var tick = function () {
        setTimeout(function () {
            if (checkFn) {
                checkCount++;
                if (checkCount > checkCountmax) {
                    resolve(true);
                }
                if (checkFn()) {
                    resolve(true);
                }
                else {
                    tick();
                }
            }
            else {
                resolve(true);
            }
        }, 50);
    };
    script.onerror = function () {
        resolve(false);
    };
    script.onload = function () {
        tick();
    };
    script.src = url;
    document.head.appendChild(script);
    return promise;
};
//# sourceMappingURL=loadScriptNoCache.js.map